export default {
    state: () => ({
        debts: [],
        isModalVisible: false,
    }),
    getters: {
        getDebts(state) {
            return state.debts;
        },
        getModalState(state) {
            return state.isModalVisible
        }
    },
    mutations: {
        setDebts(state, debts) {
            state.debts = debts;
        },
        setIsModalVisible(state, isModalVisible) {
            state.isModalVisible = isModalVisible;
        },
    },
    actions: {
        toggleIsModalVisible({state, commit}) {
            if (state.isModalVisible) {
                document.body.classList.remove('body-scroll-hidden');
            } else {
                document.body.classList.add('body-scroll-hidden');
            }
            commit('setIsModalVisible', !state.isModalVisible);
        },
    },
    namespaced: true,
};
